class FruechteboxRadios extends VariantRadios {
  constructor() {
    super();

    this.moneyFormat = this.dataset.moneyFormat;

    this.hiddenPriceInput = this.querySelector('input[name="contact[preis pro früchtebox]"]');
    this.visiblePriceInput = document.querySelector("#preis-pro-früchtebox");
    
    this.visibleVariantTitle = document.querySelector("#gewicht");
    this.visibleVariantTitle2 = document.querySelector("#fruechtebox-variant-title");
    this.fruechteboxGesamttotalElement = document.querySelector("fruechtebox-gesamttotal");
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        // update total price
        const totalPricedestination = document.getElementById("fruechtebox-total");
        const totalPricesource = html.getElementById("fruechtebox-total");
        if (totalPricesource && totalPricedestination) totalPricedestination.innerHTML = totalPricesource.innerHTML;

        const totalFormatted = this.moneyFormat.replace("{{amount}}", (this.currentVariant.price / 100).toFixed(2));
        // if (this.hiddenPriceInput) this.hiddenPriceInput.value = totalFormatted;
        if (this.visiblePriceInput) this.visiblePriceInput.textContent = totalFormatted;

        if (this.visibleVariantTitle) this.visibleVariantTitle.textContent = this.currentVariant.title;
        if (this.visibleVariantTitle2) this.visibleVariantTitle2.textContent = this.currentVariant.title;

        this.fruechteboxGesamttotalElement.updateTotal();
      });
  }
}

customElements.define('fruechtebox-radios', FruechteboxRadios);
